<div
    *transloco="let t"
    [class]="'bazis-control ' + cssClassSizeControl"
    [ngClass]="{
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': isDisabled,
        'bazis-control--dirty': ngControl.control.dirty,
        'bazis-control--empty':
            emptyValues.indexOf(ngControl.control.value) > -1 ||
            (max > 1 && !ngControl.control.value?.length),
    }"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
        } as data"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <ng-container *ngIf="uploadingDict$ | async as uploading">
            <div
                *ngFor="let fileId of fileIds; let fileIndex = index"
                class="tms-uploader__files"
            >
                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--disabled]="isDisabled"
                >
                    <div class="bazis-control__field">
                        <!-- процесс загрузки -->
                        <ng-container *ngIf="uploading[fileId]">
                            <div
                                class="bazis-file-inline"
                                *ngIf="
                                    uploading[fileId].status === 'progress' ||
                                    uploading[fileId].status === 'start'
                                "
                            >
                                <bazis-icon
                                    color="danger"
                                    name="document"
                                    class="bh-shrink"
                                ></bazis-icon>
                                <div class="bh-flex-column">
                                    <div class="bh-ellipsis bh-block">
                                        {{ uploading[fileId].name }}
                                    </div>
                                    <div class="bazis-text_minor bazis-text_secondary">
                                        .{{ uploading[fileId].extension }}
                                        {{ uploading[fileId].size | fileSize }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Загруженный существующий файл -->
                        <ng-container *ngIf="!uploading[fileId]">
                            <ng-container
                                *ngIf="fileId | entity: 'uploadable.file_upload' | async as file"
                            >
                                <app-file-inline
                                    class="bh-contents"
                                    [file]="file"
                                ></app-file-inline>
                            </ng-container>
                        </ng-container>

                        <!-- TODO: Если глобальная ошибка, не грузится файл, или не предвиденная -->
                        <!-- <ng-container>
                            <div class="tms-file-inline">
                            <bazis-icon
                                color="danger"
                                name="document"
                            ></bazis-icon>
                            <span>{{ t('form.file.titleError') }}</span>
                            </div>
                        </ng-container> -->
                    </div>
                    <div class="bazis-control__field-group__end">
                        <app-button-tooltip
                            *ngIf="!isDisabled"
                            icon="trash"
                            color="danger"
                            size="compact"
                            tooltipKey="action.delete"
                            [hidden]="uploading[fileId]"
                            (actionClick)="removeFile(fileIndex)"
                        ></app-button-tooltip>
                        <bazis-default-loader
                            *ngIf="
                                uploading[fileId]?.status === 'progress' ||
                                uploading[fileId]?.status === 'start'
                            "
                            centerX="10"
                            centerY="10"
                            radius="10"
                            theme="transparent"
                        ></bazis-default-loader>
                    </div>
                </div>
            </div>
            <div
                *ngIf="fileIds.length < max && !isDisabled"
                class="bazis-block bazis-block_hoverable"
            >
                <div class="bh-flex">
                    <bazis-icon src="/assets/icons/big/doc.svg"></bazis-icon>
                    <bazis-icon
                        class="active"
                        src="/assets/icons/big/doc-active.svg"
                    ></bazis-icon>
                    <div>
                        <span [innerHTML]="t('form.file.title')"> </span>

                        <p class="bazis-p_minor">
                            {{ t('form.title.inputFile.allowedFormats') }}
                            <ng-container
                                *ngFor="
                                    let allowedExtension of displayAllowedExtentions;
                                    let i = index
                                "
                            >
                                {{ (i > 0 ? ', ' : '') + allowedExtension }}
                            </ng-container>
                        </p>
                    </div>
                </div>

                <!--                <ng-container *ngIf="cssClassSizeControl === ''">-->
                <!--                    <div class="tms-uploader__or bazis-text_minor">-->
                <!--                        <span>{{ t('form.file.or') }}</span>-->
                <!--                    </div>-->
                <!--                    <div class="bh-flex bh-align-items-center">-->
                <!--                        <bazis-input-default-->
                <!--                            class="tms-control_no-margin"-->
                <!--                            [formControl]="searchControl"-->
                <!--                            placeholderKey="form.file.placeholderLink"-->
                <!--                        ></bazis-input-default>-->
                <!--                        <bazis-button color="secondary">{{ t('title.search') }}</bazis-button>-->
                <!--                    </div>-->
                <!--                </ng-container>-->

                <input
                    type="file"
                    [attr.multiple]="max > 1"
                    (focus)="markAsTouched()"
                    (change)="addFiles($event)"
                />
            </div>
        </ng-container>

        <ng-template #tplNoFiles>
            <span class="bazis-text_secondary">{{ t('form.title.inputFile.noFiles') }}</span>
        </ng-template>

        <div class="bazis-control__error">
            <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
        </div>

        <div class="bazis-control__note">
            <p *ngIf="noteKey">{{ t(noteKey, noteParams) }}</p>
        </div>
    </ng-container>
</div>
